<template>
<div>
    <BasicModal
      :title="'ロボ確認'"
      :isShowModal="isShowModal"
      :canCancel="true"
      @cancel="cancel">
      <div class="action-container">
        <button class="button" @click="changeByParts(scenario)">
            パーツ別確認
        </button>
        <div style="text-align: right; padding: 22px;">{{countConfirmAll(scenario)}}/{{scenario.length}}</div>
        <!--<button class="button" @click="changeByStories(scenario)"
          :disabled="isStartErrorCount(scenario) == 1">
            ストーリー別確認
        </button>
        <div style="text-align: right; padding: 22px;" v-if="isStartErrorCount(scenario) != 1">{{countConfirmStories()}}/{{allStory.length}}</div>
        <div v-if="isStartErrorCount(scenario) == 1" style="margin: -16px 0px 0px 16px;">
        <p>※ 開始設定がされてないため、ストーリー別確認ができません</p>
        </div> -->
        <div style="text-align: right; padding: 22px;"></div>
        <button class="button isFullWidth" 
            @click="openChatBotPreview(chatbot)">
            プレビューモード
        </button>
        <button class="button isFullWidth is-primary" style="margin-bottom: 0px;"
            @click="clickRoboLock(chatbot)"
            :disabled="!allPartsConfirm || errorCheck(scenario).length!=0 || isPlan()"
            v-if="!chatbot.is_confirm && checkAuthority()">
            確定する（ロックされます）
        </button>
        <button class="button noAllowButton isFullWidth" style="margin-bottom: 0px;"
            @click="clickRoboLock(chatbot)"
            v-if="chatbot.is_confirm && checkAuthority()">
            確定を解除する（ロックが解除されます）
        </button>
        <div v-if="isPlan() && checkAuthority()" style="margin: 16px 0px;">
          <p><b>※ ロックができません</b></p>
          <p>ロボの台数の上限に達しました。（上限：{{planLimit}}）</p>
          <p>新しいロボを使用するには、アーカイブも含めて既存のロボを一台削除またはロックを解除するか、スタンダードプランへの移行が必要です。</p>
        </div>
        <div v-if="!chatbot.is_confirm && checkAuthority() && (!allPartsConfirm || errorCheck(scenario).length!=0)">
          <p><b>※ 以下の理由によりロックができません</b></p>
          <p v-if="!allPartsConfirm">・確定されていないパーツがあります</p>
          <p v-for="(s, i) in errorCheck(scenario)" :key="i">
            {{s}}
          </p>
        </div>
        <div v-if="chatbot.is_confirm && changeRobo.length!=0">
          <p v-for="(r, i) in changeRobo" :key="i">
            ・{{r}} のロボ切替に設定されています
          </p>
        </div>
      </div>
      <!-- フッターアクション -->
      <div class="footer-box">
        <button class="button" @click="cancel">閉じる</button>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    },    
    user: {
      type: Object,
      required: true
    },
  },
  created () {
    this.$store.dispatch('chatbot/getScenarioList', { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
    .then((d) => {
      setTimeout(() => {
        this.scenario = this.$_.cloneDeep(d.data)
        // this.$store.dispatch('chatbot/getAllStory', this.scenario) 
        // this.errorCheck(this.scenario)
        this.allPartsConfirm = true
        for (var i of this.scenario) {
          if (!i.is_confirm) {
            this.allPartsConfirm = false
          }
        }
      }, 200)
    })
    this.$store.dispatch('chatbot/getNextRobo', this.chatbot.group)
    .then((d) => {
      for (var data of d) {
        if (data.parameter != [] && data.parameter != {} && data.parameter != null && data.parameter != "") {
          if (data.parameter.bot_id == this.chatbot.bot_id) {
            this.changeRobo.push(data.name)
          }
        }
      }
    })
  },
  data () {
    return {
      scenario: [],
      allPartsConfirm: false,
      changeRobo: [],
      planLimit: '１０台'
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioEditStats', 'chatbots', 'selectChatbot', 'allStory', 'storyConfirm']),
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    openChatBotPreview (chatbot) {
      const url = process.env.OWN_ENDPOINT + '/single/demo/' + chatbot.group + '/' + chatbot.scenario_name
      const h = window.outerHeight
      const w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
    },
    clickRoboLock (chatbot) {
      var chat = []
      for (var c of this.chatbots) {
        if (c.bot_id == chatbot.bot_id) {
          chat = c
        }
      }
      chatbot.is_confirm = !chatbot.is_confirm
      chat.is_confirm = chatbot.is_confirm
      this.$emit('clickRoboLock', chat)
    },
    errorCheck (scenario) {
      const errorList = []
        const errorCountList = {
          isStartErrorCount      : this.isStartErrorCount(scenario),
          isGoalErrorCount       : this.isGoalErrorCount(scenario),
          isImageErrorCount      : this.isImageErrorCount(scenario),
          isMovieErrorCount      : this.isMovieErrorCount(scenario),
          isEmailErrorCount      : this.isEmailErrorCount(scenario),
          isSmsErrorCount        : this.isSmsErrorCount(scenario),
          isDownloadErrorCount   : this.isDownloadErrorCount(scenario),
          isChangeRoboErrorCount : this.isChangeRoboErrorCount(scenario),
          isNextRoboErrorCount   : this.isNextRoboErrorCount(scenario),
          isIfErrorCount         : this.isIfErrorCount(scenario),
          isIfQuoteErrorCount    : this.isIfQuoteErrorCount(scenario),
          isIfUserInfoErrorCount : this.isIfUserInfoErrorCount(scenario),
          isPdfDownloadErrorCount: this.isPdfDownloadErrorCount(scenario)
        }

        // for (var i in errorCountList) {
        //   if (errorCountList[i] != 0) {
        //     return true
        //   }
        // }
        // return false
        return this.createErrorList(errorList, errorCountList)
      // }
    },
    createErrorList (errorList, errorCountList) {
      for (const k in errorCountList) {
        for (let i = 0; i < errorCountList[k]; i++) {
          switch (k) {
            case 'isStartErrorCount':
              errorList.push('・開始設定がされていません')
              break;
            case 'isGoalErrorCount':
              errorList.push('・GOAL設定がされていません')
              break;
            case 'isImageErrorCount':
              errorList.push('・画像が設定されていない画像表示パーツがあります')
              break;
            case 'isMovieErrorCount':
              errorList.push('・動画が設定されていない動画パーツがあります')
              break;
            case 'isEmailErrorCount':
              errorList.push('・メール送付パーツの宛先が設定されていません')
              break;
            case 'isSmsErrorCount':
              errorList.push('・SMS送付パーツの宛先が設定されていません')
              break;
            case 'isDownloadErrorCount':
              errorList.push('・ファイルダウンロードパーツのファイルが設定されていません')
              break;
            case 'isChangeRoboErrorCount':
              errorList.push('・ロボ切替パーツのロボが設定されていません')
              break;
            case 'isNextRoboErrorCount':
              errorList.push('・ロボ切替パーツの選択ロボが確定されていません')
              break;
            case 'isIfErrorCount':
              errorList.push('・条件で分けるパーツの条件が設定されていません')
              break;
            case 'isIfQuoteErrorCount':
              errorList.push('・条件で分けるパーツの「条件とするパーツ」が存在しないか、到達できません')
              break;
            case 'isIfUserInfoErrorCount':
              errorList.push('・条件で分けるパーツの「条件とする項目」がロボ引用設定に設定されていません')
              break;
            case 'isPdfDownloadErrorCount':
              errorList.push('・PDFダウンロードパーツの出力項目が設定されていません')
          }
        }
      }
      return errorList
    },
    isStartErrorCount (scenario) {
      if (scenario.filter(v => v.start_flg).length) return 0
      else return 1
    },
    isGoalErrorCount (scenario) {
      if (scenario.filter(v => v.is_cv).length) return 0
      else return 1
    },
    isImageErrorCount (scenario) {
      return scenario.filter(v => v.status == 5 && v.image === '' ).length
    },
    isMovieErrorCount (scenario) {
      return scenario.filter(v => v.status == 14 && v.parameter.filename === '' && v.parameter.url === '').length
    },
    isEmailErrorCount (scenario) {
      return scenario.filter(v => v.status == 10 && v.parameter.to === '').length
    },
    isSmsErrorCount (scenario) {
      return scenario.filter(v => v.status == 16 && v.parameter.to === '').length
    },
    isDownloadErrorCount (scenario) {
      return scenario.filter(v => v.status == 18 && !v.parameter.filename.length).length
    },
    isChangeRoboErrorCount (scenario) {
      return scenario.filter(v => v.status == 3 && !("bot_id" in v.parameter)).length
    },
    isNextRoboErrorCount (scenarioTable) {
      let errorCount = 0
      const parameters = scenarioTable.filter(v => v.status == 3).map(v => v.parameter)
      for (const parameter of parameters) {
        for (const c of this.chatbots) {
          if (parameter.bot_id == c.bot_id) {
            if (!c.is_confirm) {
              errorCount++
              break
            }
          } 
        }
      }
      return errorCount
    },
    isIfErrorCount (scenario) {
      // 条件で分けるはrandomを選択しておらず、ポイント、ワード、応募者情報、ミニロボ変数のどれもtermsを登録してない場合に条件が設定されていないエラーを出す
      let errorCount = 0
      const parameters = scenario.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        for (const p of parameter.filter(v => !v.random)) {
          let isNotPoint = false
          let isNotWord = false
          let isNotUserInfo = false
          let isNotMiniRobo = false
          for (const pointList of p.pointList) {
            if (pointList.terms === '') isNotPoint = true
          }
          for (const wordList of p.wordList) {
            if (wordList.terms === '') isNotWord = true
          }
          if (p.userInfoList) {
            for (const userInfoList of p.userInfoList) {
              if (userInfoList.terms === '') isNotUserInfo = true
            }
          }
          else {
            isNotUserInfo = true
          }
          if (p.miniroboVarsList) {
            for (const miniroboVarsList of p.miniroboVarsList) {
              if (miniroboVarsList.terms === '') isNotMiniRobo = true
            }
          }
          else {
            isNotMiniRobo = true
          }
          if (isNotPoint && isNotWord && isNotUserInfo && isNotMiniRobo) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isIfQuoteErrorCount (scenario) {
      // 「条件とするパーツ」が存在しない or 到達できないならエラー
      let errorCount = 0

      const next_nodes = {}
      for (let s of scenario) next_nodes[s.beforenode] = s.select.filter(sel => sel.next_node).map(sel => sel.next_node)

      const start_scenario = scenario.find(i => i.start_flg)
      if (!start_scenario) return 0
      const start_node = start_scenario.beforenode

      const end_nodes = scenario.filter(s => s.is_cv).map(s => s.beforenode)

      //開始ノードから各ノードへ、必ず通るノードを集計
      //スタートへ戻ってくるパスとゴールから先のパスは考慮しない
      let route = {[start_node]: []}
      let queue = [start_node]
      while(queue.length!=0) {
        const node = queue.shift()
        if (end_nodes.includes(node)) continue
        if (!next_nodes[node]) continue
        for (const next of next_nodes[node]) {
          const temp_route = [node].concat(route[node])
          if (!(next in route)) {
            route[next] = temp_route
            queue = queue.filter(n => n!=next)
            queue.push(next)
          }
          else {
            const pre_size = route[next].length
            route[next] = route[next].filter(n => temp_route.includes(n))
            if (pre_size != route[next].length) {
              queue = queue.filter(n => n!=next)
              queue.push(next)
            }
          }
        }
      }

      const if_scenarios = scenario.filter(v => v.status == 12 && v.parameter[0].wordList[0].terms)

      //開始ノードから当該分岐パーツまでの間に、必ず「条件とするパーツ」が含まれるかどうか
      for (const if_scenario of if_scenarios) {
        const if_node = if_scenario.beforenode
        if (!route[if_node]) continue
        for (let param of if_scenario.parameter) {
          if (!Number(param.wordList[0].parts)) continue
          const target_scenario = scenario.find(s => s.pk == param.wordList[0].parts)
          if (!target_scenario) {errorCount++;break}
          const target_node = target_scenario.beforenode
          if (!route[if_node].includes(target_node)) {errorCount++;break}
        }
      }

      return errorCount
    },
    isIfUserInfoErrorCount (scenario) {
      // 「条件とする項目」がロボ引用設定に設定されていない場合エラー
      let errorCount = 0
      const parameters = scenario.filter(v => v.status == 12).map(v => v.parameter)
      for (const parameter of parameters) {
        if (!parameter[0].userInfoList || parameter[0].userInfoList[0].terms === '') continue
        for (const p of parameter) {
          if (!this.selectChatbot.robo_arguments.map(column => column.pk).includes(p.userInfoList[0].column_pk)) {
            errorCount++
            break
          }
        }
      }
      return errorCount
    },
    isPdfDownloadErrorCount (scenario) {
      return scenario.filter(v => v.status == 21 && v.parameter.item_list === '').length
    },
    countConfirmAll (scenario) {
      let count = 0
      for (var s of scenario) {
        if (s.is_confirm) {
          count += 1
        }
      }
      return count
    },
    changeByParts (scenario) {
      this.$emit('changeByParts', scenario)
      this.cancel()
    },
    countConfirmStories () {
      var count = 0
      for (var s of this.storyConfirm) {
        if (s == "true") {
          count += 1
        }
      }
      return count
    },
    checkAuthority () {
      if(this.user.isAgent) {
        return true
      }
      if (this.chatbot.create_by == this.user.userHash) {
        return true
      }
      for (var editor of this.chatbot.editor) {
        if (editor == this.user.userHash) {
          return true
        }
      } 
      return false
    },
    isPlan () {
      var confirmCount = 0
      if (this.user.billing === 1) {
        for (var c of this.chatbots) {
          if (c.is_confirm) {
            confirmCount += 1
          }
        }
      }
      if (this.user.companyID === '1dad12e572955a7fc7fbb820a0b30a79') {
        // 介護NEXT様用
        this.planLimit = '２０台'
        if (confirmCount >= 20) {
          return true
        } else {
          return false
        }
      } else {
        this.planLimit = '１０台'
        if (confirmCount >= 10) {
          return true
        } else {
          return false
        }
      }
    },
    changeByStories(scenario) {
      this.$emit('changeByStories', scenario)
      this.cancel()
    }
  }
}
</script>

<style lang="scss" scoped>
.action-container {
  width: 100%;
  padding: 16px 48px 16px calc(10% + 48px);
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  h2 {
    font-size: 20px;
    font-weight: 600;
    width: 100%;
    text-align: left;
    margin-bottom: 16px;
  }
  button {
    width: 47%;
    margin: 16px;
    float: left;
  }
  .isFullWidth{
    width: 80%;
  }
}

.sended-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;
  th, td {
    padding: 8px;
  }
  .item {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}

.allowButton {
  background: #fffacd;
}
.noAllowButton {
  background: #c0c0c0;
}

</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailRoboConfirm.vue